import React from "react";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";

export default function GetCareer(props) {
  const item = props.data ? props.data[1] : null;
  if (!item) return null;

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "14px",
        padding: "20px 24px",
        border: "1px solid #e2e8f0",
        marginBottom: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "12px",
        transition: "border-color 0.2s ease",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.borderColor = "#cbd5e1";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.borderColor = "#e2e8f0";
      }}
    >
      {/* Job Title & Details */}
      <div>
        <Typography
          variant="h5"
          style={{
            fontWeight: 700,
            fontSize: "16px",
            color: "#0f172a",
            marginBottom: "6px",
          }}
        >
          {item.title}
        </Typography>

        <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              color: "#64748b",
              fontSize: "13px",
            }}
          >
            <LocationOnIcon style={{ fontSize: "15px", color: "#94a3b8" }} />
            Bandung, Indonesia
          </span>

          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              color: "#64748b",
              fontSize: "13px",
            }}
          >
            <WorkOutlineIcon style={{ fontSize: "15px", color: "#94a3b8" }} />
            Full-time
          </span>
        </div>
      </div>

      {/* Action Button */}
      <div>
        <Button
          component={Link}
          to={"/karir/" + item.slug}
          variant="contained"
          style={{
            backgroundColor: "#DE148C",
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "13px",
            padding: "8px 18px",
            borderRadius: "8px",
            textTransform: "none",
            boxShadow: "none",
          }}
        >
          Lihat Posisi
        </Button>
      </div>
    </div>
  );
}
